import { AfterContentChecked, Component, EventEmitter, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { AuditFilter, AuditStatus, AuditHistory } from '../../audit.model';
import { RequestResult, TableData, TableOptions } from '../../../shared/shared.model';
import { AuditService } from '../../audit.service';
import { DatePipe } from '@angular/common';
import { DISPLAY_DATE_FORMAT } from '../../../app.constants';
import { AuditFilterDialogComponent } from '../audit-filter-dialog/audit-filter-dialog.component';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'iaud-audit-update-history',
  templateUrl: 'audit-update-history.component.html',
  styleUrls: ['audit-update-history.component.scss']
})
export class AuditUpdateHistoryComponent implements OnInit, AfterContentChecked {
  @ViewChild('findingsCellTemplate') findingsCellTemplate: TemplateRef<any>;
  @ViewChild('statusCellTemplate') statusCellTemplate: TemplateRef<any>;
  @ViewChild('SMEsDetailTemplate') SMEsDetailTemplate: TemplateRef<any>;

  auditTableData: TableData<AuditHistory>;
  audit : AuditHistory;
  forceReloadEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  filterInput: FormControl = new FormControl();
  hasInitialAudits: boolean = true;
  auditId : number;  
  auditFilter: AuditFilter = this.auditService.getAuditFilter();
  auditStatus = AuditStatus;
  
  auditTableOptions: TableOptions = {
    hrefBase: '/audit',
    actionButtons: false,
    hideEditButton : true,
    hideDeleteButton : true,
    columns: [
      {
        title: 'Modify On',
        fieldName: 'updatedOn',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,        
      },
      {
        title: 'Submitter',
        fieldName: 'submiter',
      },
      {
        title: 'SME',
        fieldName: 'smeApprover',
      },    
      {
        title: 'Audit Status',
        fieldName: 'status',
      },      
      {
        title: 'Due Date',
        fieldName: 'dueDate',
        pipe: new DatePipe('en-US'),
        pipeParams: DISPLAY_DATE_FORMAT,        
      },   
    ],
    additionalInfo: [            
      {
        title: 'Audit Type',
        fieldName: 'auditType',
      },
      {
        title: 'CAPA/EC Activity Status',
        fieldName: 'capaActivityStatus',
      }, 
      {
        title: 'Audit Owner Group',
        fieldName: 'auditOwnerGroup',
      },
      {
        title: 'External Business Partner',
        fieldName: 'externalPartner', 
      },
      {
        title: 'Audit Description',
        fieldName: 'auditDescription',
      },
    ],
  };

  constructor(    
    private route: ActivatedRoute,
    private auditService: AuditService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {    
    
    this.route.paramMap.subscribe(params => {
      this.auditId = Number(params.get('id'));      
    });

    this.reloadAuditListHistory()
    .subscribe(o => this.auditTableData = o);            
  
    this.filterInput.valueChanges
      .pipe(
        distinctUntilChanged(),
        debounceTime(500)
      ).subscribe(
        () => this.forceReloadEvent.emit(true));
  }

  ngAfterContentChecked(): void {
    //this.auditTableOptions.columns[3].customTemplate = this.findingsCellTemplate;
    //this.auditTableOptions.columns[4].customTemplate = this.statusCellTemplate;
    //this.auditTableOptions.additionalInfo[3].customTemplate = this.SMEsDetailTemplate;
  }

  reloadAuditListHistory(page: number = 0, pageSize: number = 10): Observable<TableData<AuditHistory>> {
    return this.auditService.getAuditListHistory(page, pageSize, this.auditId);
  }
  deleteData(id: number): Observable<RequestResult> {
    return this.auditService.deleteAudit(id);
  }

  showFilterDlg(): void {
    const dialogRef = this.dialog.open(AuditFilterDialogComponent, {
      data: this.auditFilter || {},
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === null) {
        this.auditFilter = undefined;
        this.auditTableData.page = 0;
        this.auditService.setAuditFilter(undefined);
        this.forceReloadEvent.emit(true);
      } else if (result) {
        this.auditTableData.page = 0;
        this.auditFilter = result;
        this.auditService.setAuditFilter(this.auditFilter);
        this.forceReloadEvent.emit(true);
      }
    });
  }

  exportXls(): void {
    this.auditService.exportXls(this.auditTableData.page, this.auditTableData.pageSize, this.filterInput.value || '')
      .subscribe(data => {
        const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
      });
  }
}
